import { NgModule } from '@angular/core'
import { KeepHtmlPipe } from './keep-html.pipe'

@NgModule({
  declarations: [KeepHtmlPipe],
  exports: [KeepHtmlPipe],
})
export class KeepHtmlModule {}
